import React from 'react';
import Hero from '../components/Hero';
import OutcomeCards from '../components/OutcomeCards';
import InvolvementTiers from '../components/InvolvementTiers';
import Portfolio from '../components/Portfolio';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';
import About from '../components/About';
import Contact from '../components/Contact';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Divider from '../components/Divider';
import ParticleNetwork from '../components/ParticleNetwork';


import DocumentHead from '../components/DocumentHead';

const particleColors = { background: '#F9FAFB', accent: '#DDD6FE' };

const Home = () => {
  return (
    <div>
      <DocumentHead title={'Your website live today, $497 | Utopian Creations'} description={'Same-Day Launch: one 60-minute call with a real person and your website is live on your own domain — business email, every login in your name, $497 flat.'} />
      <Navbar />
      <main id="main-content" className="relative">
        <ParticleNetwork
          colors={particleColors}
          particleDensity={12000}
          connectionDistance={8}
          particleSpeed={0.15}
        />
        <div className="relative z-10">
          <Hero />
          <Divider />
          <InvolvementTiers />
          <Divider />
          <Portfolio />
          <Divider />
          <Process />
          <Divider />
          <OutcomeCards />
          <Divider />
          <Testimonials />
          <Divider />
          <About />
          <Divider />
          <Contact />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
